module.exports = __webpack_public_path__ + "img/_animal.da1ee14c.jpg";